import { Column } from "@bridgesplit/ui";

import BorrowAmount from "./BorrowAmount";
import BorrowSetTerm from "./BorrowSetTerm";
import BorrowCta from "./BorrowCta";
import BorrowStats from "./BorrowStats";
import BorrowCollateral from "./BorrowCollateral";
import { useMarketBorrowHooks } from "./util";

export default function BorrowCardContent() {
    useMarketBorrowHooks();
    return (
        <Column spacing={3}>
            <BorrowCollateral />
            <BorrowSetTerm />
            <BorrowAmount />
            <BorrowStats />
            <BorrowCta />
        </Column>
    );
}
